/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { DeleteCompositionsDetailMutationResponse, DeleteCompositionsDetailPathParams, DeleteCompositionsDetail404 } from "../models/DeleteCompositionsDetail";

export function getDeleteCompositionsDetailUrl(id: DeleteCompositionsDetailPathParams["id"]) {
  const res = { method: 'DELETE', url: `/compositions/${id}` as const }
  return res
}

/**
 * @summary Delete a composition by id
 * {@link /compositions/:id}
 */
export async function deleteCompositionsDetail(id: DeleteCompositionsDetailPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteCompositionsDetailMutationResponse, ResponseErrorConfig<DeleteCompositionsDetail404>, unknown>({ method : "DELETE", url : getDeleteCompositionsDetailUrl(id).url.toString(), ... requestConfig })
  return res.data
}